<!-- dead component  -->
<template>
    <div class="subscription-condition-management">
        <div class="row">
            <div class="col-12">
                <h3 class="mb-4">Zahlungsverlauf</h3>
            </div>
            <div class="col-12 mb-3">
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col"><span class="table-heading">Datum</span></th>
                                <th scope="col"><span class="table-heading">Betrag (EUR)</span></th>
                                <th scope="col"><span class="table-heading">Status</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="th-year">
                                <td colspan="3">2021</td>
                            </tr>
                            <payment-history-entry
                                v-for="entry in historyEntries"
                                :key="entry.date"
                                :entry="entry"
                            ></payment-history-entry>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PaymentHistoryEntry from "../atoms/PaymentHistoryEntry.vue";

export default {
    name: 'SubscriptionPaymentHistory',
    components: {
        PaymentHistoryEntry,
    },
    data() {
        return {
            historyEntries: [
                {date: '01.05.', value: '+300,00', text: 'Rückverbringung', state:'back'},
                {date: '02.04.', value: '-763,00', text: 'Bezahlt', state:'payed'},
                {date: '01.03.', value: '-300,00', text: 'Begleichen', state:'open'},
                {date: '01.02.', value: '-250,00', text: 'Begleichen', state:'open'},
                {date: '01.01.', value: '-200,00', text: 'Bezahlt', state:'payed'},
            ]
        }
    },
}
</script>
